import { PhoneMockup } from "./PhoneMockup";
import { Reveal } from "./Reveal";

const SHOTS = [
    {
        number: "01",
        label: "The room",
        src: "/assets/screens/social-room-lunar.webp",
        alt: "Lunar Social app — The room showing people open to meeting",
        testId: "social-strip-phone-1-room",
    },
    {
        number: "02",
        label: "The chats",
        src: "/assets/screens/social-chats-lunar.webp",
        alt: "Lunar Social app — your connections and chats",
        testId: "social-strip-phone-2-chats",
    },
    {
        number: "03",
        label: "The chat",
        src: "/assets/screens/social-chat-lunar.webp",
        alt: "Lunar Social app — a chat after both people Wave",
        testId: "social-strip-phone-3-chat",
    },
];

export const SocialVisualStrip = () => (
    <section
        data-testid="social-visual-strip-section"
        className="mx-auto max-w-6xl overflow-x-hidden px-6 py-12 sm:py-16"
    >
        <Reveal>
            <div
                data-testid="social-visual-strip-grid"
                className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4 md:grid md:grid-cols-3 md:overflow-visible md:pb-0"
            >
                {SHOTS.map((shot, i) => (
                    <figure
                        key={shot.label}
                        data-testid={`social-strip-item-${i + 1}`}
                        className="min-w-[236px] snap-center md:min-w-0"
                    >
                        <figcaption className="mb-4 flex items-baseline justify-center gap-2 text-center">
                            <span className="font-display text-xl font-medium text-[#899B6A]">
                                {shot.number}
                            </span>
                            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#4A5D23]">
                                {shot.label}
                            </span>
                        </figcaption>
                        <div className="mx-auto w-fit">
                            <PhoneMockup
                                src={shot.src}
                                alt={shot.alt}
                                testId={shot.testId}
                                compact
                            />
                        </div>
                    </figure>
                ))}
            </div>
        </Reveal>
    </section>
);
